<div class="db-overview__plugins-widget" [class.empty]="updateAvailablePlugins && !updateAvailablePlugins?.length && updateAvailableThemes && !updateAvailableThemes?.length">
  <div class="db-panel_flex">
    @if ((updateAvailablePlugins && updateAvailablePlugins.length) || (updateAvailableThemes && updateAvailableThemes.length)) {
      <div class="db-panel__header">
        <div class="db-header-wrap">
          <span>{{ 'text_managerPluginsThemes' | dbText }}</span>
          <div class="actions-container">
            <a *ngIf="selectedPluginsAndAddons.length"
               [class.ds-btn-disabled]="productListUpdateLoading"
               class="ds-btn-outline"
               (click)="!productListUpdateLoading && !!demoUser ? openCheckoutDialog() : applyBulkAction(ActivityAction.UPDATE, false)">
                <span>{{ 'text_updateSelected' | dbText}}</span>
            </a>
            <a [class.disabled]="productListUpdateLoading"
               *ngIf="updateAvailablePlugins && updateAvailablePlugins.length || updateAvailableThemes && updateAvailableThemes.length"
               class="ds-btn-gray"
               (click)="!productListUpdateLoading && !!demoUser ? openCheckoutDialog() : updateAll()">
              <span>{{ 'text_updateAll' | dbText}}</span>
            </a>
          </div>

        </div>
      </div>
    }

    <div class="db-panel__body">
      @if (!!selectedPluginsAndAddons.length && (updateAvailablePlugins || updateAvailableThemes)) {
        <div class="selected-items-count">{{ selectedPluginsAndAddons.length }} selected</div>
      }
      @if (updateAvailablePlugins && updateAvailablePlugins.length || updateAvailableThemes && updateAvailableThemes.length) {
        <ds-tabs
          [activeTabId]="filterBy.value"
          (onActiveTabChange)="onUpdatesStateChange($event)" class="db-plugins__tabs">
          <ds-tab-head [activeTabId]="filterBy.value"
                       [inline]="true"
                       [blackStyle]="true"
                       tabId="plugins">
            <span [innerHTML]="'text_managerPlugins' | dbText"></span>
          </ds-tab-head>
          <ds-tab-head [activeTabId]="filterBy.value"
                       [inline]="true"
                       [blackStyle]="true"
                       tabId="themes">
            <span [innerHTML]="'text_managerThemesShort' | dbText"></span>
          </ds-tab-head>

          <ds-tab-content>
            <div class="db-panel__body db-panel__body-main">
              @if (updateAvailablePlugins && !updateAvailablePlugins.length && filterBy.value === 'plugins') {
                <span class="empty-tab">{{ 'text_pluginsUpdated' | dbText}}</span>
              } @else if (updateAvailableThemes && !updateAvailableThemes.length && filterBy.value === 'themes') {
                <span class="empty-tab">{{ 'text_themesUpdated' | dbText}}</span>
              } @else {
                <div class="">
                  <div class="items-wrap db-panel_flex">
                    <div class="header">
                      <div class="db-product-item__checkbox mr16">
                        @if (filterBy.value === 'plugins'){
                          <input class="ds-checkbox" [class.ds-checkbox-disabled]="productListUpdateLoading" id="main"
                                 type="checkbox"
                                 (change)="toggleAllItemsSelected($event.target.checked)">
                          <label class="ds-checkbox-label purple" for="main"></label>
                        }@else{
                          <input class="ds-checkbox" [class.ds-checkbox-disabled]="productListUpdateLoading" id="main2"
                                 type="checkbox"
                                 (change)="toggleAllItemsSelected($event.target.checked)">
                          <label class="ds-checkbox-label purple" for="main2"></label>
                        }
                      </div>
                      <div class="title mr32">{{ filterBy.value === 'plugins' ? ('text_pluginName' | dbText) : ('text_themeName' | dbText)}}</div>
                      <div class="title">{{ 'text_currentVersion' | dbText}}</div>
                      <div class="title">{{ 'text_newVersion' | dbText}}</div>
                    </div>
                    <div class="db-panel__body">
                      @for (product of filteredProducts; track product.slug; let i = $index) {
                        <db-widget-product-item (toggled)="onItemToggled()"
                                                [productsLoading]="productListUpdateLoading"
                                                (updateItem)="!!demoUser ? openCheckoutDialog() : updateSingleProduct($event)"
                                                class="db-product-item-host_view_list db-product-item__{{i}}"
                                                [status]="filterBy.value === 'plugins' ? pluginUpdateStatuses()[product.slug]: themeUpdateStatuses()[product.slug]"
                                                [loading]="loadingItems.includes(product.slug)"
                                                [website]="website"
                                                [product]="product"
                                                [userPermissions]="permissions"></db-widget-product-item>
                      }
                    </div>

                  </div>
                </div>
              }

              <db-loading-screen [pageBlocker]="true" [ngClass]="{'hidden':!loading}"></db-loading-screen>
            </div>
          </ds-tab-content>
        </ds-tabs>
      } @else {
        <div class="db-no-plugins-message">
          <div class="db-no-plugins-text-wrap">
            <div class="db-no-plugins-text-title-wrap">
              <span>{{'text_managerPluginsThemes' | dbText}}</span>
            </div>
            <span class="no-plugins">{{'text_allUpToDate' | dbText}}</span>
          </div>
        </div>
      }
    </div>
  </div>
</div>

